const requestStatus = {
  WAITING: 0,
  FETCHING_LIST: 1,
  FETCHING: 2,
  CREATING: 3,
  UPDATING: 4,
  REMOVING: 5,
};

const responseStatus = {
  PENDING: 0,
  OK: 1,
  FAILED: 2,
};

export { requestStatus, responseStatus };
